import React, {useCallback, useState} from 'react';

import navigateToURL from 'lib/navigateToURL';
import ProtocolActions from 'notebook/protocols/actions/ProtocolActions';
import ProtocolStore from 'notebook/protocols/stores/ProtocolStore';
import StepByStepContainer from 'notebook/protocols/viewer/StepByStepContainer';
import useOnMount from 'ui-library/hooks/useOnMount';

interface Props {
  apiIdentifier: string;
}

function StepByStepPage({apiIdentifier}: Props): JSX.Element {
  const [protocol, setProtocol] = useState(ProtocolStore.getState().protocol);
  const closeStepByStep = useCallback(() => protocol && navigateToURL(protocol.url), [protocol]);
  const updateProtocol = useCallback(() => {
    setProtocol(ProtocolStore.getState().protocol);
  }, []);
  useOnMount(() => {
    ProtocolActions.open(apiIdentifier);
    ProtocolStore.addChangeListener(updateProtocol);
    return () => {
      ProtocolStore.removeChangeListener(updateProtocol);
    };
  });

  if (!protocol) {
    return <div />;
  }
  return <StepByStepContainer protocol={protocol} closeStepByStep={closeStepByStep} />;
}

export default StepByStepPage;
